(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TravelStyle',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('#travelstyle-trip_type').on('change', function toggleCruiseLand() {
			if ($(this).val() === 'Cruise') {
				$('#cruise-trip').removeClass('hidden');
				$('#river-cruise-trip').addClass('hidden');
				$('#tour-company').addClass('hidden');
				$('#travelstyle-river_cruise_trip').val("");
				$('#travelstyle-land_trip').val("");
			} else if ($(this).val() === 'River Cruise') {
				$('#river-cruise-trip').removeClass('hidden');
				$('#cruise-trip').addClass('hidden');
				$('#tour-company').addClass('hidden');
				$('#travelstyle-cruise_trip').val("");
				$('#travelstyle-land_trip').val("");
			} else if ($(this).val() === 'Land') {
				$('#cruise-trip').addClass('hidden');
				$('#river-cruise-trip').addClass('hidden');
				$('#tour-company').removeClass('hidden');
				$('#travelstyle-cruise_trip').val("");
				$('#travelstyle-river_cruise_trip').val("");
			} else {
				$('#tour-company').addClass('hidden');
				$('#cruise-trip').addClass('hidden');
				$('#river-cruise-trip').addClass('hidden');
				$('#travelstyle-land_trip').val("");
				$('#travelstyle-cruise_trip').val("");
				$('#travelstyle-river_cruise_trip').val("");
			}
		});

		// this will prevent the drowdown header to change.
		$form.on('shown.bs.select', function optgroupSelectAll(e) {
			e.stopPropagation();
		});

		$('select#travelstyle-where_to_next').change(function changing(e) {
			// loop thru all options of hidden multi select input
			$('#travelstyle-where_to_next option').each(function selecting(e, val) {
				var $self = $(this);

				// show span under select
				if ($self.is(":selected")) {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').removeClass('hidden');
				// hide span
				} else {
					$('.selected-destination[data-destination-id = "' + val.value + '"]').addClass('hidden');
				}
			});
		}).trigger('change');
	};

	form.confirmation = function confirmation(response)
	{
		// this means a confirm dialog needs to be thrown due to a connection error with Satori
		if (response.data.response_code === "connection_error") {
			Adzuki.AddressVerification.confirmRejected(response, form.name);

		// this is a Satori rejected address with no suggested alternative. User still should be able to force it through
		} else if (response.data.response_code > 100) {
			Adzuki.AddressVerification.confirmRejected(response, form.name);

		// a Satori alternate address suggested.  Need for user to confirm what to do with it
		} else {
			Adzuki.AddressVerification.confirmWithSuggestion(response, form.name);
		}
	};

}(jQuery, window.Adzuki || {}));
